var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6431_85204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0006 14.72L21.0006 3.71997M10.0006 14.72L13.5006 21.72C13.5444 21.8157 13.6149 21.8968 13.7035 21.9537C13.7921 22.0106 13.8952 22.0408 14.0006 22.0408C14.1059 22.0408 14.209 22.0106 14.2976 21.9537C14.3862 21.8968 14.4567 21.8157 14.5006 21.72L21.0006 3.71997M10.0006 14.72L3.00056 11.22C2.90482 11.1761 2.82369 11.1057 2.7668 11.017C2.70992 10.9284 2.67969 10.8253 2.67969 10.72C2.67969 10.6147 2.70992 10.5116 2.7668 10.4229C2.82369 10.3343 2.90482 10.2638 3.00056 10.22L21.0006 3.71997",
    stroke: "#4776E6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6431_85204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.719971)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSend);
export default __webpack_public_path__ + "static/media/ic-send.6e769b15e5026f24c6a5f0d46f38bcd3.svg";
export { ForwardRef as ReactComponent };